export default __webpack_public_path__ + "static/about-3-91a448b27915cb8f746af4b9b9698286.jpg";